import { lowerFirst } from "lodash";
import { invariant } from "@searchui-searchforms/shared/utils";
import type { FormValues } from "@/widgets/classic-form/form";
import { withPlaceholder } from "@/features/fields-grid";
import type { FieldMapperProps } from "@/features/fields-grid";
import type { RelationshipAssertion } from "@/entities/form-metadata";
import { NameAssertion } from "@/entities/form-metadata";
import type { PrefixObjectAccessor } from "@/shared/forms";
import { NameInput } from "./NameInput";

export function FamilyMemberFieldMapper({
    fieldData,
    fieldPath,
    assertion,
    inputProperties,
}: FieldMapperProps<RelationshipAssertion>) {
    invariant(fieldData, "Field data is required");

    if ([NameAssertion.GivenName, NameAssertion.Surname, NameAssertion.SecondSurname].includes(assertion)) {
        return (
            <NameInput
                metadata={fieldData}
                basePath={`${fieldPath}.${lowerFirst(assertion)}` as PrefixObjectAccessor<FormValues, []>}
                inputProperties={inputProperties}
            />
        );
    }

    // TODO: add here new relic error log
    return null;
}

export const FieldMapper = withPlaceholder(FamilyMemberFieldMapper);
